import Notifications from "../../../../pages/Others/Notifications";
import About from "../../../../pages/Others/About";

const routerNotifications = [
    {
        key: "notifications",
        path: "/notifications",
        element: <Notifications />,
    },
    {
        key: "about",
        path: "/about",
        element: <About />,
    },
]

export default routerNotifications
